;(function () {
	'use strict';

	if (!customElements.get('featured-slider')) {
		class FeaturedSlider extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector('.swiper.featured-blog-slider');
				this.nextBtn = this.querySelector('.blog-button-next');
				this.prevBtn = this.querySelector('.blog-button-prev');
				this.swiper = null;
			}

			connectedCallback() {
				// Built once. Swiper handles screen-size changes itself (the old code rebuilt a new slider on
				// every resize without removing the old one, which made it jump back and forth on phones).
				if (this.slider) {
					this.initSwiper();
				}
			}
		}

		FeaturedSlider.prototype.initSwiper = function() {
			const { slidesPerView, slidesPerViewDesktop } = this.dataset;
			if (this.swiper) {
				this.swiper.destroy(true, true);
			}

			this.swiper = new Swiper(this.slider, {
				loop: false,
				rewind: true,
				speed: 500,
				slidesPerView: 1,
				spaceBetween: 15,
				navigation: {
					nextEl: this.nextBtn,
					prevEl: this.prevBtn,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					320: {
						slidesPerView: Number(slidesPerView) || 1.2,
						spaceBetween: 15
					},
					750: {
						slidesPerView: Number(slidesPerView) || 2,
						spaceBetween: 30
					},
					1025: {
						slidesPerView: Number(slidesPerViewDesktop) || 3,
						spaceBetween: 30
					}
				}
			});
		};

		customElements.define('featured-slider', FeaturedSlider);
	}
})();
